export const environment = {
    production: false,
    googleMapsApiKey : "AIzaSyBdVmh-J0TRK-wHotg5oAaozZoUp8Cu7g0",
    apiBaseUrl : "https://sei-beachwatch-app-api-uat.azurewebsites.net",
    poiSearchUrl : "https://api.apps1.nsw.gov.au/planning/viewersf/V1/ePlanningApi/POI",
    addressSearchUrl : "https://api.apps1.nsw.gov.au/planning/viewersf/V1/ePlanningApi/address",
    addressGeometrySrvcUrl : "https://api.apps1.nsw.gov.au/planning/viewersf/V1/ePlanningApi/addressDetaillist",
    partnerLoginUrl : "https://ds-1100485--bwsit.sandbox.my.site.com/BWPartnerPortal",
    beachwatchVisionUrl : "https://www.environment.nsw.gov.au/research-and-publications/publications-search/beachwatch-2022-32-our-vision-for-the-future",
    aboutBeachwatchVideo : "beachwatch_water_quality_program_2022.mp4",
    customSearchApi: "https://www.googleapis.com/customsearch/v1",
    customSearchApiKey: "AIzaSyBCmlJJYNyjFbhwi7sbWpKaWISryYCCwHo",
    customSearchEngineId: "a55faeffdbf634bb2",
    appInsights: {
        instrumentationKey:  "98092411-ff51-4cfb-9553-55cf304351d8"
    }
};